import { forwardRef } from 'react';

interface Props extends React.SVGAttributes<SVGSVGElement> {
    incentivized: boolean;
}

type Ref = SVGSVGElement;

const IncentivizedArrow = forwardRef<Ref, Props>(({ incentivized, ...rest }, ref) => (
    <svg
        width='18'
        height='19'
        viewBox='0 0 18 19'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={`incentivized-arrow ${incentivized ? 'incentivized' : ''}`}
        {...rest}
        ref={ref}
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9.66431 0.283742C9.276 -0.0945806 8.65695 -0.0945805 8.26864 0.283742L0.304174 8.04335C-0.338453 8.66945 0.104812 9.75961 1.00201 9.75961H3V17.5225C3 18.0747 3.44772 18.5225 4 18.5225H14C14.5523 18.5225 15 18.0747 15 17.5225V9.75961H16.9309C17.8281 9.75961 18.2714 8.66945 17.6288 8.04335L9.66431 0.283742Z'
            fill='#45484B'
        />
    </svg>
));
export default IncentivizedArrow;
